<template>
    <div class="company-warehouse-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="companyWarehouseListComponent"
                :filters="filters"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'companyWarehouseRegistrationListIndex',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/companyWarehouseRegistration/components/company-warehouse-registration-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
</style>
